export abstract class TextToSpeechProvider {
  readonly apiUrl: string;
}